import React from 'react';
import InfoTile from '../InfoTile';

const pressData = [
  {
    "id": 1,
    "heading": "How sustainable fabrics are shaping the future of home décor",
    "slug": "how-sustainable-fabrics-are-shaping-the-future-of-home-decor",
    "thumbnailUrl": "",
    "mediaUrl": "blog-1",
    "articleUrl": "https://www.afaqs.com/news/brands/ddcor-launches-home-dcor-fabrics-brand-sansaar-with-ranveer-singh",
    "publishDate": "2025-05-27T00:00:00.000Z",
    "description": "D’Decor, one of the world’s largest manufacturers of soft furnishing fabrics has signed superstar Ranveer Singh...",
    "type": "press",
    "isActive": true,
    "createdAt": "2024-10-08T13:41:07.000Z",
    "updatedAt": "2024-10-10T12:51:15.000Z"
  },
  {
    "id": 2,
    "heading": "The ultimate guide to blackout & dim-out curtains with Sansaar",
    "slug": "the-ultimate-guide-to-blackout-dim-out-curtains-with-sansaar",
    "thumbnailUrl": "_A1_4212",
    "mediaUrl": "_A1_4212",
    "articleUrl": "https://www.afaqs.com/news/brands/ddcor-launches-home-dcor-fabrics-brand-sansaar-with-ranveer-singh",
    "publishDate": "2025-07-15T00:00:00.000Z",
    "description": "In the realm of interior design, light control plays a vital role in shaping a room’s atmosphere and functionality. Whether it’s managing the intensity of sunlight, enhancing privacy, or ensuring a restful environment, the right window treatment can make all the difference. Dim-out and blackout curtains are no longer merely practical additions—they are integral elements in creating a refined, harmonious living space. Sansaar, a leading name in premium sustainable home décor, offers a range of curtains that combine luxurious textures with advanced light control, while also embracing eco-conscious production practices",
    "type": "press",
    "isActive": true,
    "createdAt": "2024-10-08T13:41:07.000Z",
    "updatedAt": "2024-10-10T12:51:15.000Z"
  },
  {
    "id": 3,
    "heading": "Wedding Gifting Ideas for 2026: Why Premium Bedding Is the New Must-Have Gift",
    "slug": "wedding-gifting-ideas-for-2026-why-premium-bedding-is-the-new-must-have-gift",
    "thumbnailUrl": "/images/blog/twogift.jpeg",
    "mediaUrl": "/images/blog/twogift.jpeg",
    "articleUrl": "",
    "publishDate": "2026-01-15T00:00:00.000Z",
    "description": "Wedding gifting in India is undergoing a quiet but meaningful shift. While traditional options like crockery, décor accents, and silverware remain popular, modern couples increasingly value gifts that are thoughtful, functional, and long-lasting. As we move into 2026, premium bedding is emerging as one of the most relevant and appreciated wedding gifts combining everyday luxury with emotional value.",
    "type": "press",
    "isActive": true,
    "createdAt": "2026-02-04T00:00:00.000Z",
    "updatedAt": "2026-02-04T00:00:00.000Z"
  },
]

function BlogsTabComponent({ data }) {
  // Use actual data prop, fallback to pressData only if no data is provided
  const blogData = data && data.length > 0 ? data : pressData;

  // Debug logging
  console.log('BlogsTabComponent - data prop:', data);
  console.log('BlogsTabComponent - using blogData:', blogData);

  return (
    <div className='lyt-press'>
      <ul className='lyt-press__list-wrap'>
        {blogData?.map((item, index) => {
          // Only create Cloudinary images if mediaUrl exists and is not empty
          let myImage = null;
          let croppedImage = null;

          console.log(`BlogsTabComponent - Item ${index}: mediaUrl = "${item?.mediaUrl}"`);

          if (item?.mediaUrl && item.mediaUrl !== '' && item.mediaUrl !== null && item.mediaUrl !== 'NULL') {
            myImage = item.mediaUrl;
            croppedImage = item.mediaUrl;
            console.log(`BlogsTabComponent - Item ${index}: Using image = "${myImage}"`);
          } else {
            console.log(`BlogsTabComponent - Item ${index}: No valid image URL`);
          }

          return (
            <li className='lyt-press__list-item' key={index}>
              <InfoTile
                title={item.heading}
                mediaUrl={item?.mediaUrl}
                time={item.publishDate}
                description={item.description}
                articleUrl={`/blog/${item.slug}`}
                variant={item.type}
                croppedMediaUrl={item?.mediaUrl}
              />
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default BlogsTabComponent